import {
	registerCand,
	registerCand as registerCan,
	userInfo,
	googleLinkedInLogin,
	userAccess,
	sendCandOtp,
	sendCandOtp as sendOtp,
	checkCandidateDirect,
	checkCandOtp,
	reset_password,
	migrateGuestSearchHistory,
	checkCandidateSignin,
	getCandidateOnboard,
	setMobileToken,
} from "../../utils/apiFunctions";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Capacitor } from "@capacitor/core";
import { config } from "@/config/index.js";
import EventBus from "@/utils/EventBus";
import {
	clearAllCookiesExceptGuest,
	setRefreshToken,
	getGuestUUID,
	ensureGuestUUID,
	clearGuestUUID,
	checkAndSetAccess,
	setToken,
	getMobileToken,
} from "../../utils/tokenCheck";
import {
	required,
	email,
	maxLength,
	helpers,
	requiredIf,
	numeric,
	minLength,
} from "vuelidate/lib/validators";
import { debounce } from "lodash";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { getToken } from "../../utils/tokenCheck";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig";
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import { getProcessedToken } from "../request";
import notifications from "@/utils/notifications";

const qs = require("qs");
const sign = require("jwt-encode");

function googleAuthCodeLogin() {
	return new Promise((resolve, reject) => {
		const initAndRequest = () => {
			window.google.accounts.oauth2
				.initCodeClient({
					client_id: process.env.VUE_APP_CLIENT_ID,
					scope: "email profile openid",
					ux_mode: "popup",
					callback: (response) => {
						response.code ? resolve(response) : reject(response);
					},
					error_callback: (err) => reject(err),
				})
				.requestCode();
		};
		if (window.google && window.google.accounts) {
			initAndRequest();
		} else {
			const script = document.createElement("script");
			script.src = "https://accounts.google.com/gsi/client";
			script.async = true;
			script.defer = true;
			script.onload = initAndRequest;
			script.onerror = () =>
				reject(new Error("Failed to load Google Identity Services"));
			document.head.appendChild(script);
		}
	});
}

export default {
	name: "LoginPage",
	
	components: {
		Spinner,
	},
	props: {
		userTypeProp: {
			type: String,
			default: "candidate",
		},
	},
	mixins: [notifications],
	data() {
		return {
			redirectUrl: null,
			windowWidth: window.innerWidth,
			incomingMode: null,
			incomingUserType: null,
			isOpen: false,
			overlayOpacity: 0.46,
			mode: "login",
			userType: this.userTypeProp,
			showBusinessLogin: false,
			hideBusiness: false,

			// Unified login/signup fields
			useEmail: false,
			loginPhone: {
				number: "",
			},
			loginPhoneInvalid: false,
			loginPhoneCountryCode: "+91",
			otpCode: "",
			useOtp: true,
			setPasswordMode: false,
			setPassword: "",
			confirmPassword: "",
			otpSent: false,
			showSetPasswordOtp: false,
			isResetPasswordMode: false,
			isNewUserPasswordSetup: false,
			userExists: null,
			hasPassword: null,
			sendOtpError: "",
			// Dev/Staging only: when unchecked the backend stubs OTP as 111111 and skips SMS. Remove before production.
			sendRealOtp: false,

			// Registration/Login Shared Fields
			email: "",
			username: "",
			password: "",
			rePassword: "",
			reConfirmpassword: "",
			showPass: false,
			showPassword: false,
			showSetPassword: false,
			show: false,
			regForm: {
				firstName: "",
				lastName: "",
				email: "",
				phoneNumber: "",
				password: "",
				confirmpassword: "",
				countryCode: "+91",
				termsCondition: false,
				referralCode: "",
			},

			isFocused: false,
			sliderIndex: 0,
			sliderTimer: null,
			sliderImages: [
				require("@/assets/img/homepage/modal-left-1.png"),
				require("@/assets/img/homepage/modal-left-2.png"),
				require("@/assets/img/homepage/modal-left-3.png"),
				require("@/assets/img/homepage/modal-left-4.png"),
			],

			otpDigits: {
				num1: null,
				num2: null,
				num3: null,
				num4: null,
				num5: null,
				num6: null,
			},

			// Flags and Status
			verifyotp: false,
			LoaderStatus: false,
			invalidCredential: false,
			invalidText: "",
			successText: "",
			registered: false,
			timerOut: false,
			remainingTime: 0,
			timer: null,
			emailExists: false,
			invalidPhone: false,
			match: false,
			validPassword: false,

			// Password Validation Strings
			passwordminlength: "",
			passwordupper: "",
			passwordlower: "",
			passwordspecial: "",
			passwordnumber: "",
			wrongReferral: false,
			candExists: false,
			showPopup: false,
			countryCode: "+91",
			retryAfter: 0,
			otpExceeded: false,
			registeredLogin: false,
		};
	},

	created() {
		EventBus.$on("open-login-modal", (payload) => {
			if (payload) {
				if (typeof payload === "string") {
					this.incomingMode = payload;
				} else {
					this.incomingMode = payload.mode || "login";
					this.incomingUserType = payload.userType || null;
					this.redirectUrl = payload.redirectUrl || null;
					this.hideBusiness = payload.hideBusiness || false;
				}
			}
			this.isOpen = true;
		});
	},

	mounted() {
		this.startSlider();
		this._resizeHandler = () => {
			this.windowWidth = window.innerWidth;
		};
		window.addEventListener("resize", this._resizeHandler);
		EventBus.$on("close-login-modal", () => {
			this.isOpen = false;
		});
		console.log("[LoginPage] mounted — calling registerFCM");
		this.registerFCM().then(() => {
			console.log("[LoginPage] registerFCM complete, mobileToken:", this.mobileToken);
		});
	},

	beforeDestroy() {
		this.stopSlider();
		window.removeEventListener("resize", this._resizeHandler);
		EventBus.$off("open-login-modal");
		EventBus.$off("close-login-modal");
		document.body.classList.remove("login-modal-open");
	},

	computed: {
		...mapGetters({
			getResumeuuid: "userVUEX/getResumeUiid",
			getResumejobid: "userVUEX/getResumejobid",
		}),
		EventBus() {
			return EventBus;
		},
		//Copied getters from LoginMixin of LoginModal file.
		...mapGetters({
			userData: "userVUEX/getUserData",
			// mobileToken: "userVUEX/getMobileToken",
		}),

		isMobile() {
			return this.windowWidth <= 1028;
		},
		formattedTime() {
			let seconds = this.remainingTime;
			if (seconds < 60) {
				return `${seconds} ${seconds === 1 ? "sec" : "secs"}`;
			}

			const mins = Math.floor(seconds / 60);
			const secs = seconds % 60;

			let result = `${mins} ${mins === 1 ? "min" : "mins"}`;

			if (secs > 0) {
				result += ` ${secs} ${secs === 1 ? "sec" : "secs"}`;
			}

			return result;
		},
		loaderLabel() {
			return this.useOtp && !this.registeredLogin ? "Loading" : "Logging In";
		},
		formatEmail() {
			if (!this.userData || !this.userData.email) {
				return "";
			}
			let str = this.userData.email.split("@")[0];
			if (str.length <= 5) {
				str = str.substring(0, 1) + "****" + str.substring(str.length - 1);
			} else {
				str = str.substring(0, 2) + "****" + str.substring(str.length - 2);
			}
			let value = str + "@" + this.userData.email.split("@")[1];
			return value;
		},
		passwordValidation() {
			let val = [];
			if (this.passwordminlength) {
				val.push(this.passwordminlength);
			}
			if (this.passwordupper) {
				val.push(this.passwordupper);
			}
			if (this.passwordlower) {
				val.push(this.passwordlower);
			}
			if (this.passwordspecial) {
				val.push(this.passwordspecial);
			}
			if (this.passwordnumber) {
				val.push(this.passwordnumber);
			}
			return val.join(", ");
		},
		checkpassowrdInvalid() {
			return (
				this.passwordminlength ||
				this.passwordupper ||
				this.passwordlower ||
				this.passwordspecial ||
				this.passwordnumber
			);
		},
	},
	//Added validations for login and registration from LOginModal's LoginMixin
	validations() {
		return {
			username: {
				required,
				email,
				maxLength: maxLength(64),
				alphaEmail: (value) => {
					if (value === null) return true;
					return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
				},
			},
			email: {
				required: requiredIf(function () {
					return this.useEmail || this.userType !== "candidate";
				}),
				email,
				alphaEmail: (value) => {
					if (value === null || value === "") return true;
					return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
				},
				maxLength: maxLength(64),
			},
			loginPhone: {
				number: {
					required: requiredIf(function () {
						return !this.useEmail && this.userType === "candidate";
					}),
				},
			},
			otpCode: {
				required,
				numeric,
				minLength: minLength(6),
			},
			password: {
				required,
				maxLength: maxLength(55),
			},
			confirmpassword: {
				required,
				maxLength: maxLength(55),
			},
			confirmPassword: {
				required,
				maxLength: maxLength(55),
			},
			setPassword: {
				required,
				maxLength: maxLength(55),
			},
			rePassword: {
				required,
				maxLength: maxLength(55),
			},
			reConfirmpassword: {
				required,
				maxLength: maxLength(55),
			},
			regForm: {
				email: {
					required,
					alphaEmail: (value) => {
						if (value === null) return true;
						return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
					},
					email,
					maxLength: maxLength(64),
				},
				password: {
					required,
					maxLength: maxLength(55),
				},
				firstName: {
					required,
					maxLength: maxLength(38),
					alphaNumeric: helpers.regex(
						"alphaNumeric",
						/^(?![ .])[a-zA-Z\s.]+(?:\.[a-zA-Z\s.]+)?$/
					),
				},
				lastName: {
					required,
					maxLength: maxLength(38),
					alphaNumeric: helpers.regex(
						"alphaNumeric",
						/^(?![ .])[a-zA-Z]+(?:\.[a-zA-Z]+)?$/
					),
				},
				confirmpassword: {
					required,
					maxLength: maxLength(55),
				},
				phoneNumber: {
					required,
				},
				referralCode: {
					// alpha: helpers.regex("alpha", /^[6-9]\d{9}$/),
				},
			},
			otpDigits: {
				num1: {
					required,
				},
				num2: {
					required,
				},
				num3: {
					required,
				},
				num4: {
					required,
				},
				num5: {
					required,
				},
				num6: {
					required,
				},
			},
		};
	},

	//Adding Watchers for login and registration fields from LOginModal's LoginMixin
	watch: {
		show(val) {
			if (!val) this.registeredLogin = false;
		},
		otpCode(newVal) {
			const digits = newVal.toString().replace(/\D/g, "").slice(0, 6).split("");
			this.otpDigits.num1 = digits[0] || "";
			this.otpDigits.num2 = digits[1] || "";
			this.otpDigits.num3 = digits[2] || "";
			this.otpDigits.num4 = digits[3] || "";
			this.otpDigits.num5 = digits[4] || "";
			this.otpDigits.num6 = digits[5] || "";
			if (newVal) {
				this.$v.otpDigits.$touch();
			} else {
				this.$v.otpDigits.$reset();
			}
		},
		"loginPhone.number"(val) {
			if (!val || val.trim() === "") {
				this.loginPhoneInvalid = false;
				if (this.$v.loginPhone && this.$v.loginPhone.number) {
					this.$v.loginPhone.number.$reset();
				}
				return;
			}
			if (this.$v.loginPhone && this.$v.loginPhone.number) {
				this.$v.loginPhone.number.$touch();
			}
			const value = val.replace(/\s+/g, "");
			const cleanCountry = this.loginPhoneCountryCode
				? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
				: "91";
			if (cleanCountry === "91") {
				const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
				this.loginPhoneInvalid = !indianPhoneNumberRegex.test(value);
			}
		},
		loginPhoneCountryCode(newVal) {
			const cleanCountry = newVal
				? newVal.toString().replace(/[\s+]/g, "")
				: "91";
			if (cleanCountry === "91") {
				const val = this.loginPhone.number || "";
				if (!val || val.trim() === "") {
					this.loginPhoneInvalid = false;
					return;
				}
				const cleanVal = val.replace(/\s+/g, "");
				this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
			}
		},
		$route() {
			if (this.isOpen) {
				this.isOpen = false;
				EventBus.$emit("close-login-modal");
			}
		},
		isOpen(val) {
			if (val) {
				document.body.classList.add("login-modal-open");
			} else {
				document.body.classList.remove("login-modal-open");
				EventBus.$emit("close-login-modal");
			}
		},
		userTypeProp(val) {
			this.userType = val;
		},
		userType() {
			this.clearData();
		},
		mode(val) {
			this.clearData();
			if (val === "forgot") this.clearTimerData();
			else if (val === "register") {
				this.clearTimerData();
				this.initializeTel();
			} else {
				if (typeof this.destroyTel === "function") {
					this.destroyTel();
				}
			}
		},
		setPasswordMode(val){
			if(!val){
				this.initializeTel();
			}
		},
		username(newVal, oldVal) {
			if (newVal) {
				this.username = newVal.replace(/\s/, "").toLowerCase();
			}
			if (newVal !== oldVal) {
				this.invalidText = "";
				this.invalidCredential = false;
			}
		},
		password(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.invalidText = "";
				this.invalidCredential = false;
			}
		},
		"otpDigits.num1"(val) {
			if (val && val.length != 1) {
				this.otpDigits.num2 = val[1];
				this.otpDigits.num3 = val[2];
				this.otpDigits.num4 = val[3];
				this.otpDigits.num5 = val[4];
				this.otpDigits.num6 = val[5];
				this.otpDigits.num1 = val[0];
				const prevInput =
					val.length == 2
						? this.$refs["secondInput"]
						: val.length == 3
						? this.$refs["thirdInput"]
						: val.length == 4
						? this.$refs["fourthInput"]
						: val.length == 5
						? this.$refs["fifthInput"]
						: this.$refs["sixthInput"];
				if (prevInput) {
					prevInput.focus();
				}
			}
		},
		"regForm.phoneNumber"(val) {
			const value = val.replace(/\s+/g, "");
			if (
				this.$v.regForm.phoneNumber.$dirty &&
				this.regForm.countryCode == "+91"
			) {
				const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
				if (indianPhoneNumberRegex.test(value)) {
					this.invalidPhone = false;
				} else {
					this.invalidPhone = true;
				}
			}
		},
		"regForm.password"(value) {
			if (this.regForm.confirmpassword) {
				if (value == this.regForm.confirmpassword) {
					this.match = false;
				} else {
					this.match = true;
				}
			}
		},
		"regForm.confirmpassword"(value) {
			if (this.regForm.password) {
				if (value == this.regForm.password) {
					this.match = false;
				} else {
					this.match = true;
				}
			}
		},
		setPassword(value) {
			if (this.$v.setPassword && value && value.trim() !== "") {
				this.$v.setPassword.$touch();
			}
			if (this.confirmPassword) {
				this.match = value !== this.confirmPassword;
			}
		},
		confirmPassword(value) {
			if (this.$v.confirmPassword && value && value.trim() !== "") {
				this.$v.confirmPassword.$touch();
			}
			if (!value || value.trim() === "") {
				this.match = false;
			} else if (this.setPassword) {
				this.match = value !== this.setPassword;
			}
		},
		rePassword(value) {
			if (this.reConfirmpassword) {
				if (value == this.reConfirmpassword) {
					this.match = false;
				} else {
					this.match = true;
				}
			}
		},
		reConfirmpassword(value) {
			if (this.rePassword) {
				if (value == this.rePassword) {
					this.match = false;
				} else {
					this.match = true;
				}
			}
		},
		"regForm.email"(value) {
			if (value) {
				this.regForm.email = value.replace(/\s/, "").toLowerCase();
				if (!this.$v.regForm.email.$error && !this.$v.regForm.email.$invalid)
					this.debouncedCheckEmail();
				else this.emailExists = false;
			} else this.emailExists = false;
		},
		"regForm.referralCode"(value) {
			if (value != "" || value != null) {
				this.wrongReferral = false;
			}
		},
		otpCode(newVal, oldVal) {
			if (newVal !== oldVal && newVal !== "") {
				this.invalidText = "";
				this.invalidCredential = false;
			}
		},
	},

	methods: {
		...mapMutations({
			setToken: "userVUEX/SET_TOKEN",
			setRefreshToken: "userVUEX/SET_REFRESH_TOKEN",
		}),
		...mapActions({
			userLogin: "userVUEX/Login",
			// saveAccess: "userVUEX/saveAccess",
		}),
		clearTimerData() {
			this.remainingTime = 0;
			this.retryAfter = 0;
			this.otpExceeded = false;
		},
		formatDuration(seconds) {
			if (seconds < 60) {
				return `${seconds} ${seconds === 1 ? "sec" : "secs"}`;
			}

			const mins = Math.floor(seconds / 60);
			return `${mins} ${mins === 1 ? "min" : "mins"}`;
		},
		goToHire3xHome() {
			window.location.href = `${config.websiteBase}`;
		},
		goToDemo() {
			window.location.href = `${config.websiteBase}requestdemo`;
		},

		closeLoginModal() {
			this.isOpen = false;
		},

		//Login Button:

		async login() {
			if (this.$refs.candmail && typeof this.$refs.candmail.blur === "function")
				this.$refs.candmail.blur();
			if (this.$refs.candpass && typeof this.$refs.candpass.blur === "function")
				this.$refs.candpass.blur();
			if (
				this.$refs.phoneInput &&
				typeof this.$refs.phoneInput.blur === "function"
			)
				this.$refs.phoneInput.blur();
			this.invalidCredential = false;
			clearAllCookiesExceptGuest();
			this.clearStore();
			localStorage.clear();
			let flag = this.userType;

			if (this.useEmail || flag !== "candidate") {
				const isOtpFlow = this.useOtp && this.otpSent;
				const capturedOtpCode = this.otpCode;
				if (this.$v.email.$invalid) {
					this.$v.email.$touch();
				} else if (
					!isOtpFlow &&
					this.hasPassword !== false &&
					this.$v.password.$invalid
				) {
					this.$v.password.$touch();
				}
				if (
					!this.$v.email.$invalid &&
					(isOtpFlow ||
						this.hasPassword === false ||
						!this.$v.password.$invalid)
				) {
					this.show = true;
					this.LoaderStatus = true;
					const creds =
						isOtpFlow || this.hasPassword === false
							? { username: this.email, otp: capturedOtpCode }
							: { username: this.email, password: this.password };
					await this.loginToProjects(flag, creds);
				}
			} else {
				const isOtpFlow = this.useOtp && this.otpSent;
				const capturedOtpCode = this.otpCode;
				if (this.$v.loginPhone.number.$invalid) {
					this.$v.loginPhone.number.$touch();
					this.loginPhoneInvalid = true;
				} else if (
					!isOtpFlow &&
					this.hasPassword !== false &&
					this.$v.password.$invalid
				) {
					this.$v.password.$touch();
				}
				if (this.loginPhoneInvalid) {
					return;
				}
				if (
					!this.$v.loginPhone.number.$invalid &&
					!this.loginPhoneInvalid &&
					(isOtpFlow ||
						this.hasPassword === false ||
						!this.$v.password.$invalid)
				) {
					const phoneNumber = this.loginPhone.number.replace(/\D/g, "");
					this.show = true;
					this.LoaderStatus = true;
					const creds =
						isOtpFlow || this.hasPassword === false
							? { username: phoneNumber, otp: capturedOtpCode }
							: { username: phoneNumber, password: this.password };
					await this.loginToProjects(flag, creds);
				}
			}
		},

		async validateUser() {
			await this.login();
		},

		async loginToProjects(flag, creds) {
			this.show = true;
			this.LoaderStatus = true;
			try {
				let usernameVal = creds
					? creds.username || creds.email
					: this.username.trim();

				let userData = {
					grant_type: "password",
					client_id: Capacitor.isNativePlatform()
						? "hire3x-app"
						: "vue-test-app",
					username: usernameVal,
				};
				if (creds && creds.otp !== undefined) {
					userData.otp = creds.otp;
				} else {
					userData.password = creds ? creds.password : this.password.trim();
				}

				let userDetails = {
					keycloak: qs.stringify(userData),
					username: usernameVal,
					callSetCandAccess: true,
				};

				// 🔹 Step 1: Login API
				const res = await this.userLogin(userDetails);
				const isMobileLogin = creds && /^[0-9]+$/.test(creds.username);
				await this.getProjectsData(flag, false, undefined, isMobileLogin);
				if(!Capacitor.isNativePlatform()) this.show = false;
				this.LoaderStatus = false;
			} catch (error) {
				console.log("Inside loginToProjects catch:");
				this.show = false;
				this.LoaderStatus = false;
				console.error(error);
				if (error.response && error.response.status == 401) {
					const isOtpLogin = creds && creds.otp !== undefined;
					const attemptsLeft =
						error.response.data && error.response.data.attempts_left;
					const attemptsMsg =
						attemptsLeft !== undefined
							? ` ${attemptsLeft} ${
									attemptsLeft === 1 ? "attempt" : "attempts"
							  } left.`
							: ".";
					this.setNoAccess(
						isOtpLogin
							? `Wrong OTP.${attemptsMsg}`
							: `Invalid credentials.${attemptsMsg}`,
						true
					);
				} else if (error.response && error.response.status == 429) {
					this.setNoAccess(
						`Too many failed login attempts. Try again in ${this.formatDuration(
							error.response.data.retry_after
						)}.`,
						true
					);
				} else if (error.response && error.response.status == 400) {
					this.setNoAccess(
						error.response.data.error_description || "Login failed.",
						true
					);
				} else {
					this.setNoAccess("Login failed! Please try again.", true);
				}
			}
		},

		async getProjectsData(
			flag,
			login,
			type,
			fallbackOnUserAccessFailure = false
		) {
			let loginData = {};
			try {
				let response;
				try {
					response = await userAccess();
				} catch (userAccessError) {
					// If user-access call fails and we're on the candidate portal or in a fallback-allowed flow,
					// proceed with synthetic candidate access so registration/login is not blocked.
					if (fallbackOnUserAccessFailure) {
						console.warn(
							"user-access call failed, proceeding with candidate fallback:",
							userAccessError
						);
						loginData = { showPreference: true, type: flag };
						const data = {
							details: [{ project: "candidate", isActive: true }],
							flag,
							loginData,
							redirectUrl: this.redirectUrl,
						};
					await this.saveAccessRedirect(data);
					return;
				}
				throw userAccessError;
				}
				let projects =
					response?.data?.details?.filter((obj) => {
						let val = obj.userPermissions
							? obj.userPermissions.isActive
							: obj.isActive;
						if (val) return obj;
					}) || [];
				if (projects.length === 0) {
					this.setNoAccess("You don't have access.");
				} else if (
					projects.length == 1 &&
					projects[0].project == "candidate" &&
					flag != "candidate"
				) {
					this.setNoAccess("You don't have access.");
				} else {
					loginData = {
						showPreference: true,
						type: flag,
					};
					if (type && type == "google") {
						loginData.logged_in = "google";
					}
					let data = {
						details: projects,
						flag,
						loginData,
						redirectUrl: this.redirectUrl,
					};
					if (flag == "candidate" && !this.checkAccess(data, flag)) {
						this.setNoAccess("You don't have access!");
					} else if (this.checkAccess(data, flag)) {
						await this.saveAccessRedirect(data);
					} else {
						data.flag = "admin";
						await this.saveAccessRedirect(data);
					}
				}
			} catch (error) {
				this.LoaderStatus = false;
				console.error(error);
				this.setNoAccess("Login failed! Please try again.");
				clearAllCookiesExceptGuest();
			}
		},

		async saveAccessRedirect(data) {
			this.$store.commit("userVUEX/setCandAccess", true);
			// Moved from userVUEX.js to here after setting the CandAccess.
			// Migrate guest search history to logged-in user
			try {
				const guestUUID = getGuestUUID();
				if (guestUUID) {
					await migrateGuestSearchHistory(guestUUID);
					// Clear guest UUID after successful migration
					clearGuestUUID();
				}
			} catch (error) {
				// Log error but don't break the login flow
				console.error("Error migrating guest search history:", error);
				// Still clear the guest UUID even if migration fails
				clearGuestUUID();
			}
			const { details, flag, loginData, redirectUrl } = data;

			// Core projects to check against
			const coreProjects = [
				"recruitment",
				"assessment",
				"candidate",
				"training",
				"collegeDashboard",
			];

			// Set 'no-access' cookie for any core project NOT present in the details array
			coreProjects.forEach((projName) => {
				const hasProject = details.some((p) => p.project === projName);
				if (!hasProject) {
					document.cookie = `${projName}=no-access;${COOKIE_OPTIONS_SUFFIX}`;
				}
			});

			// Save each active project as a cookie
			details.forEach((project) => {
				document.cookie = `${project.project}=${JSON.stringify(
					project
				)};${COOKIE_OPTIONS_SUFFIX}`;
			});

			// Save loginData cookie
			document.cookie = `loginData=${JSON.stringify(
				loginData
			)};${COOKIE_OPTIONS_SUFFIX}`;
			await this.$store.dispatch("userVUEX/fetchPostLoginData");
			// Register FCM token for normal login (same as Google login)
			if (Capacitor.isNativePlatform()) {
				await this.sendAppNotification();
			}
			checkAndSetAccess();
			// Call check-user right after login — result is passed to SignupModal via EventBus
			let signinCheckData = null;
			let onboardData = null;
			try {
				// Step 1: check onboarding status first
				const onboardRes = await getCandidateOnboard();
				onboardData = onboardRes?.data?.data;
				console.log(
					"[Onboarding][loginMixin] getCandidateOnboard response:",
					onboardData
				);

				const isCompleted =
					onboardData?.onboardingCompleted === true ||
					onboardData?.onboardingCompleted === null;

				this.$store.commit("userVUEX/setOnboardingCompleted", isCompleted);

				if (isCompleted) {
					// Onboarding already done or fully skipped — skip signup modal
					console.log(
						"[Onboarding][loginMixin] skipping checkCandidateSignin — onboardingStep:",
						onboardData?.onboardingStep,
						"onboardingCompleted:",
						onboardData?.onboardingCompleted
					);
				} else {
					// Step 2: onboarding not complete — call checkCandidateSignin
					const userID = getProcessedToken();
					if (userID) {
						const checkRes = await checkCandidateSignin({
							check_completion: "true",
							userID,
						});
						if (checkRes?.data?.type === "Success") {
							signinCheckData = checkRes.data.data;
						}
					}
				}
			} catch (err) {
				console.error("[Onboarding][loginMixin] error:", err);
			}
			this.closeAndProceed(redirectUrl, signinCheckData, onboardData);
		},
		emitSignupFormIfNeeded(signinCheckData, onboardData) {
			if (!signinCheckData) return;
			const isCandVal =
				signinCheckData?.isCandidate ??
				signinCheckData?.iscandidate ??
				signinCheckData?.is_candidate;
			if (isCandVal === false || isCandVal === "false") {
				EventBus.$emit("show-signup-form", { signinCheckData });
			} else {
				// User is already a candidate — check if their onboarding is complete
				this.emitOnboardingIfIncomplete(onboardData);
			}
		},

		async emitOnboardingIfIncomplete(onboardData) {
			try {
				let data = onboardData;
				if (!data) {
					console.log("[Onboarding] calling getCandidateOnboard...");
					const res = await getCandidateOnboard();
					data = res?.data?.data;
				}
				console.log("[Onboarding] onboarding data:", data);

				if (!data || data.onboardingCompleted !== false) {
					console.log(
						"[Onboarding] onboardingCompleted is not false — no modal"
					);
					return;
				}

				// onboardingCompleted is false — open the right step
				const step = data.onboardingStep;
				console.log("[Onboarding] onboardingCompleted: false — step:", step);

				if (step === "skills" || step === "goals") {
					console.log(
						"[Onboarding] emitting show-onboarding-modal with step:",
						step
					);
					EventBus.$emit("show-onboarding-modal", { step });
				} else if (step === "resumeUpload") {
					console.log("[Onboarding] resumeUpload step — opening UploadResume");
					sessionStorage.setItem("fromOnboarding", "true");
					EventBus.$emit("show-onboarding-modal", { step: "resumeUpload" });
				} else {
					console.log("[Onboarding] unknown step — opening from WelcomeStep");
					EventBus.$emit("show-onboarding-modal");
				}
			} catch (err) {
				console.error("[loginMixin] getCandidateOnboard error:", err);
			}
		},

		closeAndProceed(redirectUrl, signinCheckData, onboardData) {
			if (redirectUrl) {
				const url = new URL(redirectUrl);
				let pathName = url.pathname;
				const pathValue = pathName.replace(/^\/builder/, "");
				this.$router
					.push({
						path: pathValue,
						query: Object.fromEntries(url.searchParams),
					})
					.then(() => {
						EventBus.$emit("login-success");
						this.emitSignupFormIfNeeded(signinCheckData, onboardData);
						this.closeLoginModal();
					});
				return;
			}
			if (this.getResumeuuid) {
				const newUser = this.$store.getters["userVUEX/getNewUseruuid"];
				if (newUser) {
					const uuid = this.getResumeuuid;
					let query = {
						from: "candidate",
						fromWebsite: true,
						uuid: uuid,
					};

					if (this.$store.getters["userVUEX/getDownloadReport"]) {
						query.downloadReport = true;
					} else {
						query.openResumeClinic = true;
					}
					this.$store.commit("userVUEX/setNewUseruuid", null);
					this.$store.commit("userVUEX/SET_RESUME_UUID", null);
					this.$store.commit("userVUEX/setresumeJobid", null);
					this.$nextTick(() => {
						this.closeLoginModal();
						this.$router
							.push({
								path: "/dashboard",
								query: query,
							})
							.then(() => {
								EventBus.$emit("login-success");
								this.emitSignupFormIfNeeded(signinCheckData, onboardData);
							})
							.catch((err) => {
								console.error("[loginMixin] /dashboard push failed:", err);
								EventBus.$emit("login-success");
								this.emitSignupFormIfNeeded(signinCheckData, onboardData);
							});
					});
					return;
				} else if (this.getResumejobid && this.getResumeuuid) {
					const jobid = this.getResumejobid;
					const uuid = this.getResumeuuid;
					this.$store.commit("userVUEX/SET_RESUME_UUID", null);
					this.$store.commit("userVUEX/setresumeJobid", null);
					this.$nextTick(() => {
						this.closeLoginModal();
						this.$router
							.push({
								path: "/job/search",
								query: {
									from: ["candidate", "resumeclinicModal"],
									tab: "hire",
									jobID: jobid,
									uuid: uuid,
									fromPage: this.$route.name,
								},
							})
							.then(() => {
								EventBus.$emit("login-success");
								this.emitSignupFormIfNeeded(signinCheckData, onboardData);
							})
							.catch((err) => {
								console.error("[loginMixin] /job/search push failed:", err);
								EventBus.$emit("login-success");
								this.emitSignupFormIfNeeded(signinCheckData, onboardData);
							});
					});
					return;
				} else if (this.getResumeuuid) {
					const uuid = this.getResumeuuid;
					this.$store.commit("userVUEX/SET_RESUME_UUID", null);
					this.$store.commit("userVUEX/setresumeJobid", null);
					this.$nextTick(() => {
						this.closeLoginModal();
						let query = {
							from: "candidate",
							uuid: uuid,
						};
						if (this.$store.getters["userVUEX/getDownloadReport"]) {
							this.$store.commit("userVUEX/setDownloadReport", false);
							query.downloadReport = true;
						} else {
							query.openResumeClinic = true;
						}

						this.$router
							.push({
								path: "/dashboard",
								query: query,
							})
							.then(() => {
								EventBus.$emit("login-success");
								this.emitSignupFormIfNeeded(signinCheckData, onboardData);
							})
							.catch((err) => {
								console.error("[loginMixin] /dashboard push failed:", err);
								EventBus.$emit("login-success");
								this.emitSignupFormIfNeeded(signinCheckData, onboardData);
							});
					});
					return;
				}
				this.$nextTick(() => {
					EventBus.$emit("login-success");
					this.emitSignupFormIfNeeded(signinCheckData, onboardData);
					this.closeLoginModal();
				});
				return;
			} else {
				this.$nextTick(() => {
					this.closeLoginModal();
					EventBus.$emit("login-success");
					this.emitSignupFormIfNeeded(signinCheckData, onboardData);
					// On native, LoginPage is the full screen — there is no modal to close
					// and no dashboard underneath. Push to dashboard explicitly.
					if (Capacitor.isNativePlatform()) {
						this.$router.push({ path: "/homepage", query: { from: "candidate" } });
					}
				});
			}
		},

		async sendAppNotification() {
			const token = getMobileToken();
			try {
				if (token) {
					await setMobileToken({
						token,
						platform: Capacitor.getPlatform(),
					});
				}
			} catch (error) {
				console.error("Notification error:", error);
			}
		},

		createjwtToken(token) {
			const secret = token;
			const data = {
				exp: Math.floor(Date.now() / 1000) + 60 * 60,
				sub: token,
			};
			const jwt = sign(data, secret, { algorithm: "RS256" });
			return jwt;
		},
		async ssoLogin(tokenval, authtoken, type, isMobile = false) {
			try {
				this.LoaderStatus = true;
				let payload = {
					token: authtoken,
					authType: type,
					isMobile: isMobile,
					origin: window.location.origin,
				};
				const resp = await googleLinkedInLogin(payload, tokenval);
				if (resp.status == 200) {
					this.$store.commit("userVUEX/SET_TOKEN", resp.data.data.access_token);
					this.$store.commit(
						"userVUEX/SET_REFRESH_TOKEN",
						resp.data.data.refresh_token
					);
				setToken(resp.data.data.access_token);
				setRefreshToken(resp.data.data.refresh_token);
			if (isMobile) {
				await this.sendAppNotification();
			}
			this.getProjectsData("candidate", false, "google");
				} else {
					this.LoaderStatus = false;
					this.setNoAccess("Invalid credentials.");
				}
			} catch (error) {
				console.log(error);
				this.LoaderStatus = false;
				this.setNoAccess("Login failed.");
			}
		},

		async googleLogin() {
			// Native mobile: use Capacitor GoogleAuth plugin
			if (Capacitor.isNativePlatform()) {
				try {
					try {
						await GoogleAuth.signOut();
					} catch (signOutError) {
						console.log("Sign out before login (optional):", signOutError);
					}
					const user = await GoogleAuth.signIn();
					console.log("[GoogleAuth] signIn response:", JSON.stringify(user));
					if (user && user.serverAuthCode) {
						const code = user.serverAuthCode;
						const jwt = this.createjwtToken(code);
						this.show = true;
						this.ssoLogin(jwt, code, "google", true);
					} else if (user && user.authentication && user.authentication.idToken) {
						const idToken = user.authentication.idToken;
						const jwt = this.createjwtToken(idToken);
						this.show = true;
						this.ssoLogin(jwt, idToken, "google", true);
					} else if (user && user.idToken) {
						const idToken = user.idToken;
						const jwt = this.createjwtToken(idToken);
						this.show = true;
						this.ssoLogin(jwt, idToken, "google", true);
					} else {
						console.error("No valid token found in response:", user);
						this.setNoAccess("Google Sign-In failed. Please try again.");
					}
				} catch (error) {
					console.error("Native Google Sign-In error:", error);
					this.setNoAccess("Google Sign-In failed. Please try again.");
				}
			} else {
				// Web browser: use Google Identity Services
				googleAuthCodeLogin()
					.then((response) => {
						const code = response.code;
						this.show = true;
						const jwt = this.createjwtToken(code);
						this.ssoLogin(jwt, code, "google");
					})
					.catch((error) => {
						console.error("Web Google Sign-In error:", error);
						this.setNoAccess("Google Sign-In failed. Please try again.");
					});
			}
		},

		// Methods from LoginMixin of LoginModal file.
		// ─── Helpers ──────────────────────────────────────────────────────────────
		startSlider() {
			this.sliderTimer = setInterval(() => {
				this.nextSlide();
			}, 5000);
		},
		stopSlider() {
			if (this.sliderTimer) {
				clearInterval(this.sliderTimer);
			}
		},
		nextSlide() {
			this.sliderIndex = (this.sliderIndex + 1) % this.sliderImages.length;
		},
		setSlide(index) {
			this.sliderIndex = index;
			this.stopSlider();
			this.startSlider();
		},
		clearAndReset(clearRedirect = true, clearSession = false) {
			if (!clearRedirect) {
				if (this.incomingMode) {
					this.mode = this.incomingMode;
					this.incomingMode = null;
				} else {
					this.mode = "login";
				}
				if (this.incomingUserType) {
					this.userType = this.incomingUserType;
					this.incomingUserType = null;
				} else {
					this.userType = "candidate";
				}
			}
			this.show = false;
			this.LoaderStatus = false;
			if (clearSession) {
				clearAllCookiesExceptGuest();
				this.$store.commit("userVUEX/setCandAccess", false);
				localStorage.clear();
			}
			this.clearData();
			if (clearRedirect) {
				this.redirectUrl = null;
				setTimeout(() => {
					this.hideBusiness = false;
				}, 300);
				try {
					this.$store.commit("userVUEX/setDownloadReport", false);
				} catch (e) {
					console.log(e);
				}
			} else {
				this.$store.dispatch("userVUEX/clearAllVuex", { keepFlowData: true });
			}
		},
		toggleLoginMode(isEmail) {
			this.useEmail = isEmail;
			this.email = "";
			if (this.loginPhone) {
				this.loginPhone.number = "";
			}
			this.loginPhoneInvalid = false;
			this.sendOtpError = "";
			this.invalidCredential = false;
			this.invalidText = "";
			this.$v.$reset();
		},
		handleEdit() {
			this.setPasswordMode = false;
			this.showSetPasswordOtp = false;
			this.isResetPasswordMode = false;
			this.otpSent = false;
			this.otpCode = "";
			this.setPassword = "";
			this.confirmPassword = "";
			this.sendOtpError = "";
			this.userExists = null;
			this.hasPassword = null;
			this.useOtp = true;
			this.password = "";
			this.invalidCredential = false;
			this.invalidText = "";
			this.clearOtp();
			this.clearTimer();
			this.timerOut = false;
			this.otpExceeded = false;
			this.$v.$reset();
		},
		validatePhoneNumber(val) {
			if (!val) {
				this.loginPhoneInvalid = false;
				return;
			}
			const dialCode = this.loginPhoneCountryCode
				? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
				: "91";
			if (dialCode === "91") {
				const cleanVal = val.replace(/\s+/g, "");
				this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
			}
		},
		handlePhoneValidation(isInvalid) {
			const dialCode = this.loginPhoneCountryCode
				? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
				: "91";
			if (dialCode === "91") {
				const cleanVal = (this.loginPhone.number || "").replace(/\s+/g, "");
				this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
			} else {
				this.loginPhoneInvalid = isInvalid;
			}
		},
		resetValidation(field) {
			if (this.$v[field]) {
				this.$v[field].$reset();
			}
		},
		usePassword() {
			this.useOtp = false;
			this.otpCode = "";
			this.clearOtp();
			this.resetValidation("password");
			this.invalidCredential = false;
			this.invalidText = "";
		},
		usePasswordOrSetup() {
			if (this.hasPassword === false) {
				// Existing user but no password set — go to Set Password page
				this.isNewUserPasswordSetup = true;
				this.openPasswordSetup(true);
			} else {
				this.usePassword();
			}
		},
		useOtpLogin() {
			this.useOtp = true;
			this.password = "";
			this.otpCode = "";
			this.resetValidation("password");
			this.resetValidation("otpCode");
			this.invalidCredential = false;
			this.invalidText = "";
		},
		openPasswordSetup(isReset = false) {
			this.setPasswordMode = true;
			this.isResetPasswordMode = isReset;
			// Always show OTP field immediately — no two-button flow
			this.showSetPasswordOtp = true;
			this.password = "";
			this.otpCode = "";
			this.setPassword = "";
			this.confirmPassword = "";
			this.match = false;
			this.passwordminlength = "";
			this.passwordupper = "";
			this.passwordlower = "";
			this.passwordspecial = "";
			this.passwordnumber = "";
			this.validPassword = false;
			this.clearOtp();
			this.resetValidation("password");
			this.resetValidation("setPassword");
			this.resetValidation("confirmPassword");
			this.invalidCredential = false;
			this.invalidText = "";
			// For reset-password flow: trigger OTP send immediately
			if (isReset) {
				this._savedTimerOut = this.timerOut;
				this._savedRetryAfter = this.retryAfter;
				this._savedRemainingTime = this.remainingTime;
				this.$nextTick(() => {
					this.forgotPassword();
				});
			}
		},
		terms() {
			const link = document.createElement("a");
			link.href =
				"https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/Terms+and+Conditions+Hire3x.docx";
			link.download = "Terms_and_Conditions_Hire3x.docx"; // Suggested filename
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		goToPrivacyPolicy() {
			window.open(
				"https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/General+Privacy+Policy+for+hire3x.pdf"
			);
		},
		convertToUppercase() {
			this.regForm.referralCode = this.regForm.referralCode.toUpperCase();
		},
		handleFocus() {
			this.isFocused = true;
		},
		handleBlur() {
			this.isFocused = false;
		},

		checkAccess(data, flag) {
			let val = data.details.filter((obj) => {
				if (obj.project == flag) {
					let active = obj.userPermissions
						? obj.userPermissions.isActive
						: obj.isActive;
					if (active) return obj;
				}
			});
			return val.length !== 0;
		},

		setFailurePopup(message, login) {
			this.LoaderStatus = false;
			this.showPopup = true;
			this.invalidText = message;
			setTimeout(() => {
				this.showPopup = false;
				this.invalidText = "";
				this.candExists = false;
				if (login) {
					this.clearData();
					this.mode = "login";
					this.userType = "candidate";
				}
			}, 5000);
		},
		setNoAccess(message, notClear) {
			this.LoaderStatus = false;
			this.invalidCredential = true;
			this.invalidText = message;
			if (!notClear) {
				setTimeout(() => {
					this.invalidText = "";
					this.invalidCredential = false;
				}, 5000);
			}
		},
		clearStore() {
			this.$store.commit("userVUEX/SET_TOKEN", "");
			this.$store.commit("userVUEX/SET_REFRESH_TOKEN", "");
		},
		clearData() {
			this.invalidCredential = false;
			this.invalidText = "";
			this.email = "";
			this.invalidPhone = false;
			this.emailExists = false;
			this.countryCode = "+91";
			this.phoneNumber = "";
			this.wrongReferral = false;
			this.registered = false;
			this.successText = "";
			this.username = "";
			this.password = "";
			this.showPassword = false;
			this.showconfirmPassword = false;
			this.passwordminlength = "";
			this.passwordupper = "";
			this.passwordlower = "";
			this.passwordspecial = "";
			this.passwordnumber = "";
			this.validPassword = false;
			this.match = false;
			this.regForm = {
				firstName: "",
				lastName: "",
				email: "",
				phoneNumber: "",
				password: "",
				confirmpassword: "",
				countryCode: "+91",
				termsCondition: false,
				referralCode: "",
			};
			this.rePassword = "";
			this.reConfirmpassword = "";
			this.otpSent = false;
			if (this.loginPhone) {
				this.loginPhone.number = "";
			}
			this.loginPhoneCountryCode = "+91";
			this.loginPhoneInvalid = false;
			this.otpCode = "";
			this.useOtp = true;
			this.setPasswordMode = false;
			this.setPassword = "";
			this.confirmPassword = "";
			this.showSetPasswordOtp = false;
			this.isResetPasswordMode = false;
			this.isNewUserPasswordSetup = false;
			this.userExists = null;
			this.hasPassword = null;
			this.sendOtpError = "";
			this.clearOtp();
			this.$v.$reset();
			if (this.$v.otpCode) {
				this.$v.otpCode.$reset();
			}
		},

		// ─── OTP Timer ────────────────────────────────────────────────────────────

		pad(val) {
			return val < 10 ? "0" + val : val;
		},
		startTimer() {
			clearTimeout(this.timer);
			this.remainingTime = this.retryAfter;
			this.timer = setInterval(() => {
				if (this.remainingTime > 0) {
					this.remainingTime--;
				} else {
					clearInterval(this.timer);
					this.timerOut = false;
					this.otpExceeded = false;
					this.remainingTime = this.retryAfter;
				}
			}, 1000);
		},
		clearTimer() {
			clearInterval(this.timer);
		},

		// ─── OTP Input ────────────────────────────────────────────────────────────

		restrictToOneDigit(event) {
			if (["e", "E", "+", "-", "."].includes(event.key)) {
				event.preventDefault();
				return;
			}
			const currentValue = event.target.value;
			if (currentValue && currentValue.length >= 1) {
				event.preventDefault();
			}
		},
		moveToNextField(event, nextInputRef, prevInputRef) {
			if (event.target.value && event.target.value.length >= 1) {
				const nextInput = this.$refs[nextInputRef];
				if (this.handleBackspace(event)) {
					if (nextInput && event.keyCode !== 9) nextInput.focus();
				} else {
					const prevInput = this.$refs[prevInputRef];
					if (prevInput) {
						setTimeout(() => {
							prevInput.focus();
						}, 0);
					}
				}
			}
		},
		handleBackspace(event) {
			return !(event.keyCode === 8 || event.keyCode === 46);
		},
		clearOtp() {
			this.otpDigits.num1 = null;
			this.otpDigits.num2 = null;
			this.otpDigits.num3 = null;
			this.otpDigits.num4 = null;
			this.otpDigits.num5 = null;
			this.otpDigits.num6 = null;
			this.otpCode = "";
			const nextInput = this.$refs["firstInput"];
			if (nextInput) nextInput.focus();
			this.$v.otpDigits.$reset();
			if (this.$v.otpCode) {
				this.$v.otpCode.$reset();
			}
		},

		// ─── Password validation ──────────────────────────────────────────────────

		validatePassword(PasswordField = "password") {
			let pwd = "";
			if (PasswordField === "rePassword") {
				pwd = this.rePassword;
			} else if (PasswordField === "setPassword") {
				pwd = this.setPassword;
			} else {
				pwd = this.regForm.password;
			}
			this.passwordminlength = pwd.length < 6 ? "Min 6 char required" : "";
			this.passwordupper = !/^(.*[A-Z]){1,}.*$/.test(pwd) ? "1 Upper Case" : "";
			this.passwordlower = !/^(.*[a-z]){3}.*$/.test(pwd) ? "3 Lower Case" : "";
			this.passwordspecial =
				!/^(.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]){1,}.*$/.test(pwd)
					? "1 special character"
					: "";
			this.passwordnumber = !/^(.*\d){1,}.*$/.test(pwd) ? "1 number" : "";
			this.validPassword =
				this.passwordminlength ||
				this.passwordupper ||
				this.passwordlower ||
				this.passwordspecial ||
				this.passwordnumber
					? true
					: false;
		},
		preventPaste(event) {
			event.preventDefault();
		},
		isLetter(e) {
			let char = String.fromCharCode(e.keyCode); // Get the character
			if (/^[A-Za-z .]+$/.test(char)) return true; // Match with regex
			else e.preventDefault(); // If not match, don't add to input text
		},
		isLetterandSpace(e) {
			let char = String.fromCharCode(e.keyCode);
			if (/^[A-Za-z]+$/.test(char)) return true;
			else e.preventDefault();
		},
		otpNumbersOnly(evt) {
			const charCode = evt.key;
			if (charCode < "0" || charCode > "9") {
				evt.preventDefault();
			}
		},
		numbersOnly(evt) {
			if (evt.target.nodeName === "INPUT") {
				const charCode = evt.key;
				if ((charCode < "0" || charCode > "9") && charCode !== ".") {
					evt.preventDefault();
				} else {
					if (
						this.regForm.countryCode == "+91" &&
						this.regForm.phoneNumber?.length >= 11
					) {
						evt.preventDefault();
					}
				}
			}
		},

		/**
		 * Step 2: Verify OTP and complete registration.
		 */

		// OTP code from OTPVerification

		async registerCandidate() {
			this.verifyotp = true;
			if (this.$refs.setPassField) this.$refs.setPassField.blur();
			if (this.$refs.confirmPassField) this.$refs.confirmPassField.blur();
			if (this.$refs.candmail) this.$refs.candmail.blur();
			if (this.$refs.phoneInput) this.$refs.phoneInput.blur();
			if (this.$refs.candotp) this.$refs.candotp.blur();

			// Validate identifier
			if (this.useEmail && this.$v.email.$invalid) {
				this.$v.email.$touch();
			} else if (!this.useEmail && this.$v.loginPhone.number.$invalid) {
				this.$v.loginPhone.number.$touch();
			} else if (this.$v.otpCode.$invalid) {
				this.$v.otpCode.$touch();
			} else if (this.setPasswordMode && this.$v.setPassword.$invalid) {
				this.$v.setPassword.$touch();
			} else if (
				this.setPasswordMode &&
				(this.$v.confirmPassword.$invalid || this.match)
			) {
				this.$v.confirmPassword.$touch();
			}

			this.show = true;
			this.verifyotp = false;
			const otpVal = this.otpCode;
			let payload = { ...this.userData };
			if (this.setPassword) payload.password = this.setPassword.trim();
			payload.otp = Number(otpVal);
			if (this.getResumeuuid) payload.uuid = this.getResumeuuid;

			try {
				const response = await registerCan(payload);
				if (response.status == 200) {
					if (this.getResumeuuid) {
						this.$store.commit("userVUEX/setNewUseruuid", true);
					}
					clearInterval(this.timer);
					this.show = false;
					this.registered = true;
					this.successText = "Registered successfully";
					setTimeout(async () => {
						this.registered = false;
						this.successText = "";
						this.registeredLogin = true;
						this.show = true;
						try {
							// Determine username: email or phone number (without country code)
							let username = "";
							if (this.useEmail) {
								username = (this.userData.email || this.email || "").trim();
							} else {
								username = String(
									this.userData.phoneNumber || this.loginPhone.number || ""
								).replace(/\D/g, "");
							}
							// Use setPassword if one was set during registration, otherwise use the OTP
							const registrationPassword =
								this.setPassword ||
								(this.userData && this.userData.password) ||
								"";
							const regCreds = registrationPassword
								? { username, password: registrationPassword }
								: { username, otp: this.otpCode };
							await this.loginToProjects("candidate", regCreds);
						} catch (err) {
							console.error("Auto-login failed:", err);
							this.setFailurePopup(
								"Login failed after registration. Please log in manually."
							);
						} finally {
							this.clearData();
							this.clearOtp();
							this.$store.commit("userVUEX/setUserData", {});
						}
					}, 2000);
				} else if (response.status == 401 || response.status == 400) {
					this.show = false;
					this.setNoAccess("Wrong OTP");
				} else {
					this.show = false;
					this.setFailurePopup("Registration failed. Please try again.");
				}
			} catch (error) {
				this.show = false;
				const status = error.response && error.response.status;
				const msg =
				error.response && error.response.data && error.response.data.data
					? error.response.data.data.Detail
					: null;
				if (status == 400 || status == 401) {
				this.setNoAccess(msg || "Wrong OTP");
				} else {
				this.setFailurePopup(msg || "Registration failed. Please try again.");
				}
			}
		},

		async register(resend) {
			clearAllCookiesExceptGuest();
			this.clearStore();
			localStorage.clear();
			if (resend) {
				this.clearOtp();
			}
			if (!resend) {
				if (this.$refs.pass && typeof this.$refs.pass.blur === "function")
					this.$refs.pass.blur();
				if (this.$refs.fname && typeof this.$refs.fname.blur === "function")
					this.$refs.fname.blur();
				if (this.$refs.lname && typeof this.$refs.lname.blur === "function")
					this.$refs.lname.blur();
				if (this.$refs.mail && typeof this.$refs.mail.blur === "function")
					this.$refs.mail.blur();
				if (
					this.$refs.phoneInput &&
					typeof this.$refs.phoneInput.blur === "function"
				)
					this.$refs.phoneInput.blur();
				if (this.$refs.referal && typeof this.$refs.referal.blur === "function")
					this.$refs.referal.blur();

				if (this.regForm.firstName && this.$v.regForm.firstName.$invalid) {
					this.$v.regForm.firstName.$touch();
				} else if (this.regForm.lastName && this.$v.regForm.lastName.$invalid) {
					this.$v.regForm.lastName.$touch();
				} else if (this.useEmail && this.$v.email.$invalid) {
					this.$v.email.$touch();
				} else if (
					!this.useEmail &&
					(this.$v.loginPhone.number.$invalid || this.loginPhoneInvalid)
				) {
					this.$v.loginPhone.number.$touch();
				} else if (this.setPasswordMode && this.$v.setPassword.$invalid) {
					this.$v.setPassword.$touch();
				} else if (
					this.setPasswordMode &&
					(this.$v.confirmPassword.$invalid || this.match)
				) {
					this.$v.confirmPassword.$touch();
				}
			}
			const isIdentifierValid = this.useEmail
				? !this.$v.email.$invalid
				: !this.$v.loginPhone.number.$invalid && !this.loginPhoneInvalid;
			if (
				(!resend &&
					isIdentifierValid &&
					!this.match &&
					!this.validPassword &&
					!this.loginPhoneInvalid) ||
				resend
			) {
				this.show = true;
				this.LoaderStatus = true;
				if (!resend) {
					let userdata = {};
					if (this.useEmail) {
						if (this.email) userdata.email = this.email.trim();
					} else {
						userdata.countryCode = this.loginPhoneCountryCode
							? this.loginPhoneCountryCode.trim()
							: "+91";
						userdata.phoneNumber = (this.loginPhone.number || "").replace(
							/\D/g,
							""
						);
					}
					// Add name fields if we have them
					if (this.regForm.firstName)
						userdata.firstName = this.regForm.firstName.trim();
					if (this.regForm.lastName)
						userdata.lastName = this.regForm.lastName.trim();
					if (this.regForm.referralCode)
						userdata.code = this.regForm.referralCode.trim();
					if (this.password) userdata.password = this.password.trim();
					if (this.confirmPassword)
						userdata.confirmPassword = this.confirmPassword.trim();
					this.$store.commit("userVUEX/setUserData", userdata);
				}
				// Build the sendOtp payload
				let otpPayload = {};
				if (this.useEmail) {
					otpPayload = {
						email: !resend ? this.email.trim() : this.userData.email,
					};
				} else {
					if (!resend) {
						const dialCode = this.loginPhoneCountryCode
							? this.loginPhoneCountryCode.startsWith("+")
								? this.loginPhoneCountryCode
								: "+" + this.loginPhoneCountryCode
							: "+91";
						otpPayload = {
							countryCode: dialCode,
							phoneNumber: (this.loginPhone.number || "").replace(/\D/g, ""),
						};
					} else {
						otpPayload = {
							countryCode: this.userData.countryCode,
							phoneNumber: String(this.userData.phoneNumber).replace(/\D/g, ""),
						};
					}
				}
				try {
					// ── Step 1 (first call only): check user info via checkCandidateSignin ──
					if (!resend) {
						const checkPayload = this.useEmail
							? { email: this.email.trim() }
							: {
									countryCode: this.loginPhoneCountryCode
										? this.loginPhoneCountryCode.startsWith("+")
											? this.loginPhoneCountryCode
											: "+" + this.loginPhoneCountryCode
										: "+91",
									phoneNumber: (this.loginPhone.number || "").replace(
										/\D/g,
										""
									),
							  };
						const checkRes = await checkCandidateSignin(checkPayload);
						const checkData = checkRes.data?.data || checkRes.data;
						this.userExists = checkData.exists;
						this.hasPassword = checkData.hasPassword;
					}

					// Set type AFTER checkCandidateSignin so this.userExists is populated
					otpPayload.type =
						this.userExists === false ? "register-account" : "login-account";
					otpPayload.sendRealOtp = this.sendRealOtp;

					// ── Step 2: send OTP via sendOtp ──────────────────────────────────
					const otpRes = await sendOtp(otpPayload);

					if (otpRes.status == 200) {
						const resData = otpRes.data?.data || otpRes.data;
						const rawRetryAfter =
							resData.retryAfter ?? resData.cooldownSeconds ?? 0;
						this.retryAfter = rawRetryAfter >= 60 ? rawRetryAfter : 60;
						this.sendOtpError = "";
						this.show = false;
						this.LoaderStatus = false;
						if (this.retryAfter) {
							this.timerOut = true;
							this.startTimer();
						}
						this.otpSent = true;
						if (!resend && this.userType !== "candidate") this.mode = "otp";
					} else if (otpRes.status == 429) {
						this.show = false;
						this.LoaderStatus = false;
						const cooldown =
							otpRes.data?.data?.cooldownSeconds ??
							otpRes.data?.data?.retryAfter ??
							60;
						this.retryAfter = cooldown >= 60 ? cooldown : 60;
						this.otpSent = true;
						this.otpExceeded = true;
						const detail429 = otpRes.data?.data?.Detail;
						this.sendOtpError =
							detail429 && detail429.length <= 120
								? detail429
								: "Please wait before requesting another OTP.";
						if (this.retryAfter) {
							this.timerOut = true;
							this.startTimer();
						}
						if (!resend && this.userType !== "candidate") this.mode = "otp";
					} else {
						this.show = false;
						this.LoaderStatus = false;
						this.sendOtpError = "Failed to send OTP. Please try again.";
					}
				} catch (error) {
					console.log(error);
					this.show = false;
					this.LoaderStatus = false;
					const status = error.response && error.response.status;
					const errData =
						error.response && error.response.data && error.response.data.data;
					const rawDetail = errData && errData.Detail;
					const msg =
						rawDetail && rawDetail.length <= 120
							? rawDetail
							: "Failed to send OTP. Please try again.";

					if (status == 429) {
						const cooldown =
							errData?.cooldownSeconds ?? errData?.retryAfter ?? 60;
						this.retryAfter = cooldown >= 60 ? cooldown : 60;
						this.otpSent = true;
						this.otpExceeded = true;
						this.sendOtpError =
							msg !== "Failed to send OTP. Please try again."
								? msg
								: "Please wait before requesting another OTP.";
						if (this.retryAfter) {
							this.timerOut = true;
							this.startTimer();
						}
						if (!resend && this.userType !== "candidate") this.mode = "otp";
					} else {
						if (status == 409) this.candExists = true;
						this.sendOtpError = msg;
					}
				}
			}
		},

		async handleRegister(resend) {
			await this.register(resend);
		},

		async forgotPassword(val) {
			if (val === "resend") {
				this.clearOtp();
			}
			const useEmailForForgot = this.useEmail || this.userType !== "candidate";
			if (!val) {
				if (useEmailForForgot) {
					if (this.$refs.candmail) this.$refs.candmail.blur();
					this.$v.email.$touch();
					if (this.$v.email.$invalid) return;
				} else {
					if (this.$refs.phoneInput) this.$refs.phoneInput.blur();
					this.$v.loginPhone.number.$touch();
					if (this.$v.loginPhone.number.$invalid || this.loginPhoneInvalid)
						return;
				}
			}

			let fullPhone = "";
			if (!useEmailForForgot) {
				const dialCode = this.loginPhoneCountryCode.startsWith("+")
					? this.loginPhoneCountryCode
					: "+" + this.loginPhoneCountryCode;
				fullPhone = dialCode + this.loginPhone.number;
			}

			this.show = true;
			this.LoaderStatus = true;
			try {
				if (!val) {
					let userdata = { type: "reset-password" };
					if (useEmailForForgot) {
						userdata.email = this.email.trim();
					} else {
						const dialCode = this.loginPhoneCountryCode.startsWith("+")
							? this.loginPhoneCountryCode
							: "+" + this.loginPhoneCountryCode;
						userdata.countryCode = dialCode;
						userdata.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
					}
					this.$store.commit("userVUEX/setUserData", userdata);
				}
				let payload = { type: "reset-password" };
				if (!val) {
					if (useEmailForForgot) {
						payload.email = this.email.trim();
					} else {
						const dialCode = this.loginPhoneCountryCode.startsWith("+")
							? this.loginPhoneCountryCode
							: "+" + this.loginPhoneCountryCode;
						payload.countryCode = dialCode;
						payload.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
					}
				} else {
					// resend: restore from userData stored on first call
					if (this.userData.email) {
						payload.email = this.userData.email;
					} else {
						payload.countryCode = this.userData.countryCode;
						payload.phoneNumber = String(this.userData.phoneNumber).replace(
							/\D/g,
							""
						);
					}
				}
				const response = await sendOtp(payload);
				if (response.status == 200 || response.status == 429) {
					if (response.status == 429) this.otpExceeded = true;
					this.clearTimer();
					this.timerOut = false;
					this.retryAfter =
						response.status == 429
							? response.data.data.cooldownSeconds
							: response.data.data.retryAfter;
					this.show = false;
					this.LoaderStatus = false;
					if (this.retryAfter) {
						this.timerOut = true;
						this.startTimer();
					}
					if (!val) {
						// Candidate reset flow stays in setPasswordMode screen
						if (this.userType === "candidate") {
							this.setPasswordMode = true;
							this.isResetPasswordMode = true;
							this.showSetPasswordOtp = true;
						} else {
							this.mode = "forgotOtp";
						}
					}
				} else {
					this.show = false;
					this.LoaderStatus = false;
					this.setNoAccess(
						this.useEmail
							? "This email ID is not registered with Hire3x."
							: "This phone number is not registered with Hire3x."
					);
				}
			} catch (error) {
				this.show = false;
				this.LoaderStatus = false;
				if (error.response && error.response.status == 429) {
					this.otpExceeded = true;
					this.clearTimer();
					this.timerOut = false;
					this.retryAfter = error.response.data.data.cooldownSeconds;
					if (this.retryAfter) {
						this.timerOut = true;
						this.startTimer();
					}
					if (!val) {
						// Candidate reset flow stays in setPasswordMode screen
						if (this.userType === "candidate") {
							this.setPasswordMode = true;
							this.isResetPasswordMode = true;
							this.showSetPasswordOtp = true;
						} else {
							this.mode = "forgotOtp";
						}
					}
				} else {
					this.setNoAccess(
						this.useEmail
							? "This email ID is not registered with Hire3x."
							: "This phone number is not registered with Hire3x."
					);
				}
			}
		},
		async sendOTP(val) {
			await this.forgotPassword(val);
		},

		async resetPasswordOTP() {
			this.verifyotp = true;
			if (this.userType === "candidate") {
				if (this.$v.otpCode.$invalid) {
					this.$v.otpCode.$touch();
					return;
				}
				this.show = true;
				this.LoaderStatus = true;
				this.verifyotp = false;
				let otpVal = this.otpCode;
				let payload = this.userData;
				payload.otp = Number(otpVal);
				try {
					const response = await checkCandOtp(payload);
					if (response.status == 200) {
						this.$store.commit("userVUEX/setUserData", {});
						this.$store.commit("userVUEX/setUserData", payload);
						await this.resetPassword();
					} else if (response.status == 400) {
						this.show = false;
						this.LoaderStatus = false;
						this.setNoAccess("OTP didn't match");
						this.clearOtp();
					} else {
						this.show = false;
						this.LoaderStatus = false;
						this.setNoAccess("Something went wrong!");
						this.clearOtp();
					}
				} catch (error) {
					this.show = false;
					this.LoaderStatus = false;
					const msg =
						error.response && error.response.data && error.response.data.data
							? error.response.data.data.Detail
							: "Something went wrong!";
					this.setNoAccess(msg);
					this.clearOtp();
				}
			} else {
				this.$v.otpDigits.$touch();
				if (
					!this.$v.otpDigits.num1.$invalid &&
					!this.$v.otpDigits.num2.$invalid &&
					!this.$v.otpDigits.num3.$invalid &&
					!this.$v.otpDigits.num4.$invalid &&
					!this.$v.otpDigits.num5.$invalid &&
					!this.$v.otpDigits.num6.$invalid
				) {
					this.show = true;
					this.LoaderStatus = true;
					this.verifyotp = false;
					let otpVal = `${this.otpDigits.num1}${this.otpDigits.num2}${this.otpDigits.num3}${this.otpDigits.num4}${this.otpDigits.num5}${this.otpDigits.num6}`;
					let payload = this.userData;
					payload.otp = Number(otpVal);
					try {
						const response = await checkCandOtp(payload);
						if (response.status == 200) {
							this.$store.commit("userVUEX/setUserData", {});
							this.$store.commit("userVUEX/setUserData", payload);
							this.$nextTick(() => {
								this.LoaderStatus = false;
								this.mode = "reset";
							});
						} else if (response.status == 400) {
							this.setNoAccess("OTP didn't match");
							this.clearOtp();
						} else {
							this.setNoAccess("Something went wrong!");
							this.clearOtp();
						}
					} catch (error) {
						const msg =
							error.response && error.response.data && error.response.data.data
								? error.response.data.data.Detail
								: "Something went wrong!";
						this.setNoAccess(msg);
						this.clearOtp();
					}
				}
			}
		},

		async handleSubmit() {
			if (this.$refs.candmail && typeof this.$refs.candmail.blur === "function")
				this.$refs.candmail.blur();
			if (this.$refs.candpass && typeof this.$refs.candpass.blur === "function")
				this.$refs.candpass.blur();
			if (
				this.$refs.phoneInput &&
				typeof this.$refs.phoneInput.blur === "function"
			)
				this.$refs.phoneInput.blur();
			if (this.$refs.candotp && typeof this.$refs.candotp.blur === "function")
				this.$refs.candotp.blur();

			let flag = this.userType;

			if (this.setPasswordMode) {
				// Step 1: validate passwords first
				this.$v.setPassword.$touch();
				this.$v.confirmPassword.$touch();
				if (
					this.$v.setPassword.$invalid ||
					this.$v.confirmPassword.$invalid ||
					this.match
				) {
					return;
				}

				// Step 2: passwords passed — now validate OTP
				this.$v.otpCode.$touch();
				if (this.$v.otpCode.$invalid) {
					return;
				}
				if (this.isResetPasswordMode || this.isNewUserPasswordSetup) {
					await this.resetPasswordOTP();
				} else {
					await this.registerCandidate();
				}
				return;
			}

			if (flag === "candidate") {
				if (this.useOtp) {
					if (!this.otpSent) {
						await this.register();
					} else {
						this.$v.otpCode.$touch();
						if (this.$v.otpCode.$invalid) {
							return;
						}

						if (this.userExists === false) {
							await this.registerCandidate();
						} else {
							await this.login();
						}
					}
				} else {
					await this.login();
				}
			} else {
				await this.login();
			}
		},

		// Reset password code from ResetPassword

		async resetPassword() {
			if (this.userType === "candidate") {
				if (this.$refs.setPassField) this.$refs.setPassField.blur();
				if (this.$refs.confirmPassField) this.$refs.confirmPassField.blur();
				this.rePassword = this.setPassword;
				this.reConfirmpassword = this.confirmPassword;
				this.validatePassword("rePassword");
			} else {
				if (this.$refs.pass) this.$refs.pass.blur();
				if (this.$refs.passnew) this.$refs.passnew.blur();
			}

			if (this.$v.rePassword.$invalid || this.validPassword) {
				this.$v.rePassword.$touch();
			}
			if (this.$v.reConfirmpassword.$invalid || this.match) {
				this.$v.reConfirmpassword.$touch();
			}

			// Passwords invalid — stop here regardless of phase
			if (
				this.$v.rePassword.$invalid ||
				this.$v.reConfirmpassword.$invalid ||
				this.match ||
				this.validPassword
			) {
				return;
			}

			// Phase 1 (candidate reset): passwords valid but OTP not sent yet → send OTP now
			if (this.isResetPasswordMode && !this.showSetPasswordOtp) {
				await this.forgotPassword();
				if (this.setPasswordMode) {
					this.showSetPasswordOtp = true;
				}
				return;
			}

			if (!this.otpCode || String(this.otpCode).trim().length < 6) {
				this.$v.otpCode.$touch();
			}
			if (
				!this.$v.rePassword.$invalid &&
				!this.$v.reConfirmpassword.$invalid &&
				!this.match &&
				!this.validPassword &&
				this.otpCode &&
				String(this.otpCode).trim().length >= 6
			) {
				this.show = true;
				try {
					let payload = {
						otp: Number(this.otpCode),
						password: this.rePassword.trim(),
					};
					// Build identifier: email or phone depending on login mode
					if (this.userData.email) {
						payload.email = this.userData.email;
					} else {
						payload.countryCode = this.userData.countryCode;
						payload.phoneNumber = String(this.userData.phoneNumber).replace(
							/\D/g,
							""
						);
					}
					const res = await reset_password(payload);
					if (res.status == 200) {
						this.$store.commit("userVUEX/setUserData", {});
						this.show = false;
						this.registered = true;
						this.successText = "Password set successfully";
						const _isNewUserPasswordSetup = this.isNewUserPasswordSetup;
						const _savedPassword = this.rePassword;
						const _savedEmail = this.email;
						const _savedPhone = this.loginPhone ? this.loginPhone.number : "";
						const _savedCountryCode = this.loginPhoneCountryCode;
						const _savedUseEmail = this.useEmail;
						setTimeout(async () => {
							this.registered = false;
							this.successText = "";
							if (this.userType === "candidate") {
								if (_isNewUserPasswordSetup) {
									// Auto-login with the newly set password
									this.show = true;
									const flag = this.userType;
									const username = _savedUseEmail
										? _savedEmail
										: _savedPhone.replace(/\s+/g, "");
									await this.loginToProjects(flag, {
										username,
										password: _savedPassword,
									});
									return;
								}

								// Normal reset-password flow: restore identifier and go back to password screen
								const savedEmail = _savedEmail;
								const savedPhone = _savedPhone;
								const savedCountryCode = _savedCountryCode;
								const savedUseEmail = _savedUseEmail;
								// Set mode first — the mode watcher calls clearData() so all
								// state (including otpSent) is cleanly reset before we restore.
								this.mode = "login";
								this.setPasswordMode = false;
								// Restore phone/email immediately (synchronously) after clearData()
								// so the tel-input component picks up the correct country code on mount.
								this.loginPhoneCountryCode = savedCountryCode;
								if (this.loginPhone) {
									this.loginPhone.number = savedPhone;
								}
								this.useEmail = savedUseEmail;
								this.$nextTick(() => {
									this.email = savedEmail;
									if (this.loginPhone) {
										this.loginPhone.number = savedPhone;
									}
									this.loginPhoneCountryCode = savedCountryCode;
									this.useEmail = savedUseEmail;
									this.useOtp = false;
									this.otpSent = true;
									this.userExists = true;
									this.hasPassword = true;
									this.isResetPasswordMode = false;
									this.clearTimer();
									this.timerOut = this._savedTimerOut || false;
									this.retryAfter = this._savedRetryAfter || 0;
									this.remainingTime = this._savedRemainingTime || 0;
									this.otpExceeded = false;
									this._savedTimerOut = null;
									this._savedRetryAfter = 0;
									this._savedRemainingTime = 0;
									// Resume the countdown using the already-restored remainingTime.
									// Do NOT call startTimer() — it resets remainingTime to retryAfter.
									if (this.timerOut && this.remainingTime > 0) {
										this.timer = setInterval(() => {
											if (this.remainingTime > 0) {
												this.remainingTime--;
											} else {
												clearInterval(this.timer);
												this.timerOut = false;
												this.otpExceeded = false;
											}
										}, 1000);
									}
									if (savedUseEmail) {
										this.$store.commit("userVUEX/setUserData", {
											email: savedEmail,
										});
									} else {
										const dialCode = savedCountryCode.startsWith("+")
											? savedCountryCode
											: "+" + savedCountryCode;
										this.$store.commit("userVUEX/setUserData", {
											countryCode: dialCode,
											phoneNumber: savedPhone,
										});
									}
									this.$v.$reset();
								});
							} else {
								this.mode = "login";
								this.setPasswordMode = false;
							}
						}, 3000);
					} else {
						this.show = false;
						this.setFailurePopup("Password reset failed");
					}
				} catch (error) {
					this.show = false;
					const detailMsg =
						error.response && error.response.data && error.response.data.data
							? error.response.data.data.Detail
							: "Password reset failed";
					this.setFailurePopup(detailMsg);
				}
			}
		},

		// ─── Email existence check ────────────────────────────────────────────────
		debouncedCheckEmail: debounce(function () {
			this.checkEmailExistsLocal();
		}, 500),
		async checkEmailExistsLocal() {
			try {
				const res = await checkCandidateDirect({ email: this.regForm.email });
				if (res.status == 200) {
					this.emailExists = res.data.data?.isCandidateValid;
				}
			} catch (error) {
				console.error(error);
			}
		},

		// ─── Initialize phone number input ────────────────────────────────────────────────
		initializeTel() {
			this.$nextTick(() => {
				let inputs = [];
				const els = document.querySelectorAll("#candidatePhone");
				els.forEach((el) => {
					inputs.push(el);
				});

				if (inputs.length === 0) {
					let inputComponent = this.$refs.phoneInput;
					if (Array.isArray(inputComponent)) {
						inputComponent.forEach((c) => {
							if (c && c.$el) inputs.push(c.$el);
							else if (c) inputs.push(c);
						});
					} else if (inputComponent) {
						if (inputComponent.$el) inputs.push(inputComponent.$el);
						else inputs.push(inputComponent);
					}
				}

				if (this.itis && Array.isArray(this.itis)) {
					this.itis.forEach((iti) => iti.destroy());
				}
				this.itis = [];

				inputs.forEach((input) => {
					if (!input) return;
					const iti = intlTelInput(input, {
						utilsScript:
							"https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.3/js/utils.js",
						showSelectedDialCode: true,
						initialCountry: "IN",
						autoPlaceholder: "Phonee",
					});
					this.itis.push(iti);

					const initialDialCode = iti.getSelectedCountryData().dialCode;
					this.dialCodeLength = initialDialCode.length;
					this.loginPhoneCountryCode = initialDialCode;

					const dropdown = input.parentElement.querySelector(
						".iti__flag-container"
					);
					if (dropdown) {
						dropdown.addEventListener("click", function () {
							const dropdownContainer = document.querySelector(
								".iti__dropdown-content"
							);
							if (dropdownContainer) {
								const searchField =
									dropdownContainer.querySelector(".iti__search-input");
								if (searchField) {
									searchField.value = "";
									const inputEvent = new Event("input", {
										bubbles: true,
									});
									searchField.dispatchEvent(inputEvent);
								}
							}
						});
					}

					// Manually add an event listener to the input field for country change
					input.addEventListener("countrychange", () => {
						const code = iti.getSelectedCountryData().dialCode;
						this.dialCodeLength = code.length;
						this.loginPhoneCountryCode = code;
						this.regForm.countryCode = "+" + code;

						const value = (this.loginPhone.number || "").replace(/\s+/g, "");
						const regValue = (this.regForm.phoneNumber || "").replace(
							/\s+/g,
							""
						);

						if (code !== "91" && value) {
							this.loginPhoneInvalid = !iti.isValidNumber();
						} else if (code === "91") {
							this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(value);
						}

						if (
							this.regForm.countryCode !== "+91" &&
							this.regForm.phoneNumber
						) {
							this.invalidPhone = !iti.isValidNumber();
						} else if (this.regForm.countryCode === "+91") {
							const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
							this.invalidPhone = !indianPhoneNumberRegex.test(regValue);
						}
					});

					input.addEventListener("input", () => {
						const code = iti.getSelectedCountryData().dialCode;
						const value = (this.loginPhone.number || "").replace(/\s+/g, "");
						const regValue = (this.regForm.phoneNumber || "").replace(
							/\s+/g,
							""
						);

						if (code !== "91" && value) {
							this.loginPhoneInvalid = !iti.isValidNumber();
						}
						if (this.regForm.countryCode !== "+91" && regValue) {
							this.invalidPhone = !iti.isValidNumber();
						}
					});
				});
			});
		},
		destroyTel() {
			if (this.itis && Array.isArray(this.itis)) {
				this.itis.forEach((iti) => iti.destroy());
				this.itis = null;
			}
			if (this.iti) {
				this.iti.destroy();
				this.iti = null;
			}
		},
	},
};
